/**
 * Created by Andrey Popov on 3/17/21.
 */

const DialoguePersonTitleView = cc.Scale9Sprite.extend({ 
    ctor: function (person) {
        this._super(bundles.dialogues.frames.dialogue_name, cleverapps.UI.getScale9Rect(bundles.dialogues.frames.dialogue_name, cleverapps.UI.Scale9Rect.TwoPixelXY));

        this.setAnchorPoint(0.5, 0.5);

        this.setCascadeOpacityEnabled(true);
        this.setVisible(false);
        this.isSnown = false;
        const originalSize = this.getContentSize();

        let title = `Dialogue.person.${person.role}`;

        if (!Messages.has(title)) {
            if (cleverapps.config.debugMode) {
                console.error(`person has no name! ${title} is missing in localization`);
            }

            title = "Dialogue.person.noName";
        }
        const titleText = cleverapps.UI.generateOnlyText(Messages.get(title), cleverapps.styles.FONTS.DIALOGUE_PERSON_TITLE_TEXT);

        titleText.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        this.addChild(titleText);

        const styles = cleverapps.styles.DialoguePersonTitleView.text;

        this.setContentSize2(
            Math.max(titleText.width + styles.padding.x * 2, originalSize.width),
            Math.max(titleText.height + styles.padding.y * 2, originalSize.height)
        );
        this.onResize();

        titleText.setAlignment(styles);
    },

    onResize: function () {
        this.setScale(cleverapps.resolution.mode === cleverapps.WideMode.VERTICAL ? 0.6 : 1);
    },

    show: function () {
        if (this.isShown) {
            return;
        }

        this.stopAllActions();
        this.isSnown = true;

        this.setOpacity(0);
        this.setVisible(true);

        this.runAction(new cc.FadeIn(0.2));
    },

    hide: function () {
        if (!this.isSnown) {
            return;
        }

        this.stopAllActions();
        this.isSnown = false;

        this.runAction(new cc.Sequence(
            new cc.FadeOut(0.2),
            new cc.Hide()
        ));
    }
});

cleverapps.styles.DialoguePersonTitleView = {
    text: {
        x: { align: "center" },
        y: { align: "center", dy: -3 },
        padding: {
            x: 5,
            y: 0
        }
    }
};
